<template>
  <ValidationProvider
    :rules="required ? { required: { allowFalse: false } } : {}"
    v-slot="{ classes, errors }"
    slim
  >
    <div class="form-check">
      <label :class="[
        'form-label',
        'form-check-label',
        { 'text-danger': !!errors.length }
      ]">
        <input type="checkbox"
          :class="['form-check-input', ...classes]"
          :aria-invalid="errors.length ? 'true' : 'false'"
          :aria-required="required"
          v-bind="$attrs"
          v-model="model"
          v-focus="hasFocus"
        />
        <slot>{{ label }}</slot>
        <span v-if="required" class="text-danger">*</span>
      </label>
    </div>
  </ValidationProvider>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';

export default {
  inheritAttrs: false,

  mixins: [focusable],

  props: {
    label: String,

    required: {
      type: Boolean,
      default: () => false
    },

    value: Boolean
  },

  computed: {
    model: {
      get: ({ value }) => value,

      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>
